import {
  MICRODOSE_MAX_BMI_THRESHOLD,
  MICRODOSE_MIN_BMI_THRESHOLD,
} from "@/constants/bmi";
import { useQuizContext } from "@/pages/quiz/context";
import { calculateBMI } from "@/utils";

const useIsMicrodose = () => {
  const { answers } = useQuizContext();

  const heightWeightAnswer = Object.values(answers).find(
    (a) =>
      a?.blockName === "height-weight-input-fields" ||
      a?.blockName === "height-weight-input-fields-with-bmi"
  ) as { value: { weight: string; feet: string; inches: string } };

  const weight = Number(heightWeightAnswer?.value?.weight || 0);
  const feet = Number(heightWeightAnswer?.value?.feet || 0);
  const inches = Number(heightWeightAnswer?.value?.inches || 0);

  // Match the 2-decimal BMI shown to the user, so e.g. 21.997 (shown as
  // 22.00) is treated as microdose.
  const bmi = Number(calculateBMI(weight, feet, inches).toFixed(2));

  return {
    isMicrodose:
      bmi >= MICRODOSE_MIN_BMI_THRESHOLD && bmi < MICRODOSE_MAX_BMI_THRESHOLD,
  };
};

export { useIsMicrodose };
